// src/pages/dashboard/Sales.jsx
import React from "react";
import PageShell from "./PageShell";
export default function Sales() {
  return <PageShell title="Sales" />;
}
